export const appToaster = {
	successHead  : 'Thành công',
	errorHead    : 'Có lỗi xảy ra',
	apiErrorHead : 'Thất bại'
};
